import React, { useState } from 'react';
import "./CatchEmAll.css";
import Header from '../app/Header';

const tempMasteryData = [
	{ championName: "Click the button to load summoner mastery" },
];

const MasteryRow = (props) => {
	const lastPlayedIsSet = props.friendlyLastPlayTime !== undefined;
	const lastPlayedIsAbsolute = lastPlayedIsSet && props.friendlyLastPlayTime.absolute !== undefined;
	const rowClass = props.rowNumber === 150 && props.showBorder ? 'MasteryRow has-border' : 'MasteryRow';
	return (
		<tr className={rowClass}>
			<td className='rowNumber'>{props.rowNumber}</td>
			<td>{props.championName}</td>
			<td>{props.championLevel}</td>
			<td>{props.championPoints}</td>
			<td>
				<span className='last-played-time-amount'>{lastPlayedIsSet ? lastPlayedIsAbsolute ? props.friendlyLastPlayTime.absolute : props.friendlyLastPlayTime.amount : ''}</span>
				<span className='last-played-time-unit'>{lastPlayedIsSet ? lastPlayedIsAbsolute ? '' : props.friendlyLastPlayTime.unit : ''}</span>
			</td>
			<td className={props.challengeRank?.toLowerCase()}>{props.challengeRank}</td>
			<td className={`chest ${props.chestGranted ? 'on' : 'off'}`}><img src='/league-chest.png' /></td>
		</tr>
	)
}

const MasteryRows = (props) => {
	const { data, sortColumn, sortDirection } = props;
	const showBorder = sortColumn === 'level' && sortDirection === 'desc';
	return (
		<tbody>
			{data.map((row, index) =>
				<MasteryRow
					key={index}
					rowNumber={index + 1}
					championName={row.championName}
					championLevel={row.championLevel}
					championPoints={row.championPoints}
					friendlyLastPlayTime={row.friendlyLastPlayTime}
					challengeRank={row.challengeRank}
					chestGranted={row.chestGranted}
					showBorder={showBorder}
				/>
			)}
		</tbody>
	)
}

function CatchEmAll() {

	const [rows, setRows] = useState(tempMasteryData);
	const [sortedRows, setSortedRows] = useState(tempMasteryData);
	const [summonerNameInput, setSummonerName] = useState('');
	const [apiKeyInput, setApiKeyInput] = useState('');
	const [sortColumn, setSortColumn] = useState('level');
	const [sortDirection, setSortDirection] = useState('desc');
	const [error, setError] = useState('');

	const challengeRankThresholds = {
		"Iron": 100,
		"Bronze": 500,
		"Silver": 1000,
		"Gold": 5000,
		"Platinum": 10000,
		"Diamond": 50000,
		"Master": 100000,
		"Grandmaster": 107500,
		"Challenger": 115000,
	};

	function countChampsInRankWithin150(rank) {
		return <tr>
			<td className={rank.toLowerCase()}>{rank}</td>
			<td>{rows.filter((r, index) => index < 150 && r.challengeRank === rank).length}</td>
			<td style={{ color: '#ffffff33' }}>{numberWithCommas(challengeRankThresholds[rank])} points</td>
		</tr>
	}

	return (
		<>
			<Header />
			<div className="CatchEmAll">
				<div>
					<div className='input-container'>
						<input id="summonerName" value={summonerNameInput} onInput={e => setSummonerName(e.target.value)} placeholder="Summoner Name" />
						<input id="apiKey" type="password" value={apiKeyInput} onInput={e => setApiKeyInput(e.target.value)} placeholder="Riot API Key" />
						<button onClick={populateTable}>Get Summoner Mastery</button>
						{error && <div className='error-message'>{error}</div>}
					</div>
				</div>
				<table className='champs-in-rank'>
					{countChampsInRankWithin150("Challenger")}
					{countChampsInRankWithin150("Grandmaster")}
					{countChampsInRankWithin150("Master")}
					{countChampsInRankWithin150("Diamond")}
					{countChampsInRankWithin150("Platinum")}
					{countChampsInRankWithin150("Gold")}
					{countChampsInRankWithin150("Silver")}
					{countChampsInRankWithin150("Bronze")}
					{countChampsInRankWithin150("Iron")}
				</table>
				<table className='mastery-table'>
					<thead>
						<tr className='headerRow'>
							<th>#</th>
							<th onClick={() => handleSort('name')}>
								Name
								<span className="sort-indicator">
									{sortColumn === 'name' && (sortDirection === 'asc' ? '▲' : '▼')}
								</span>
							</th>
							<th onClick={() => handleSort('level')}>
								Level
								<span className="sort-indicator">
									{sortColumn === 'level' && (sortDirection === 'asc' ? '▲' : '▼')}
								</span>
							</th>
							<th onClick={() => handleSort('points')}>
								Points
								<span className="sort-indicator">
									{sortColumn === 'points' && (sortDirection === 'asc' ? '▲' : '▼')}
								</span>
							</th>
							<th onClick={() => handleSort('playTime')}>
								Last Played
								<span className="sort-indicator">
									{sortColumn === 'playTime' && (sortDirection === 'asc' ? '▲' : '▼')}
								</span>
							</th>
							<th>Challenge Rank</th>
							<th>Chest</th>
						</tr>
					</thead>
					<MasteryRows data={sortedRows} sortColumn={sortColumn} sortDirection={sortDirection} />
				</table>
			</div>
		</>
	);


	async function populateTable(e) {
		e.preventDefault();

		if (summonerNameInput.length === 0) {
			setError('Please enter a summoner name');
			return;
		}

		const effectiveApiKey = apiKeyInput || process.env.REACT_APP_RG_API_KEY;
		if (!effectiveApiKey) {
			setError('Please provide an API key');
			return;
		}

		setRows([{ championName: "Loading" }]);
		setSortedRows([{ championName: "Loading" }]);
		setError('');

		const championDatas = await getDataDragonRealm("na")
			.then(realm => fetch(`https://ddragon.leagueoflegends.com/cdn/${realm.n.champion}/data/en_US/champion.json`))
			.then(rawResponse => rawResponse.json())
			.then(response => { return response.data; });

		const gameName = summonerNameInput.includes('#') ? summonerNameInput.split('#')[0] : summonerNameInput;
		const tagLine = summonerNameInput.includes('#') ? summonerNameInput.split('#')[1] : 'na1';
		console.log(gameName);
		console.log(tagLine);

		const riotAccount = await getRiotAccount(gameName, tagLine, effectiveApiKey);
		const summoner = await getSummonerByPUUID(riotAccount.puuid, effectiveApiKey);

		// Get a modified version of the summoner's mastery list
		const summonerMastery = await getMasteryList(summoner.puuid, effectiveApiKey)
			// Add entries for zero-mastery champions
			.then(masteryList => {
				const masteryListIds = masteryList.map(masteryEntry => `${masteryEntry.championId}`);
				Object.values(championDatas).forEach(championData => {
					if (masteryListIds.indexOf(championData.key) === -1)
						masteryList.push({
							"puuid": summoner.puuid,
							"championId": championData.key,
							"championLevel": 0,
							"championPoints": 0,
							"lastPlayTime": 0,
							"championPointsSinceLastLevel": 0,
							"championPointsUntilNextLevel": 0,
							"chestGranted": false,
							"tokensEarned": 0,
							"summonerId": summoner.id
						});
				});
				return masteryList;
			})
			// Populate masteryList entries with: championName, friendlyLastPlayTime, and challengeRank
			.then(masteryList => {
				masteryList.forEach(masteryEntry => {
					masteryEntry.championName = Object.values(championDatas).find(championData => championData.key == masteryEntry.championId).name;

					masteryEntry.friendlyLastPlayTime = epochToFriendlyTime(masteryEntry.lastPlayTime);

					let ranksBelowChampPoints = Object.entries(challengeRankThresholds).filter(rank => rank[1] < masteryEntry.championPoints);
					let highestPointRankKVP = ranksBelowChampPoints[ranksBelowChampPoints.length - 1];
					masteryEntry.challengeRank = typeof highestPointRankKVP !== 'undefined' ? highestPointRankKVP[0] : "";

					// Keep raw value for sorting, formatted value for display
					masteryEntry.championPointsRaw = masteryEntry.championPoints;
					masteryEntry.championPoints = numberWithCommas(masteryEntry.championPoints);
				});
				return masteryList;
			})
			.then(masteryList => {
				setRows(masteryList);
				// Sort based on current sort state (from URL or defaults)
				const sorted = [...masteryList].sort((a, b) => {
					let aVal, bVal;

					switch (sortColumn) {
						case 'name':
							aVal = a.championName;
							bVal = b.championName;
							return sortDirection === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);

						case 'level':
							aVal = a.championLevel;
							bVal = b.championLevel;
							return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;

						case 'points':
							aVal = a.championPointsRaw || 0;
							bVal = b.championPointsRaw || 0;
							return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;

						case 'playTime':
							aVal = a.lastPlayTime || 0;
							bVal = b.lastPlayTime || 0;
							return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;

						default:
							return 0;
					}
				});
				setSortedRows(sorted);
				return masteryList;
			})
			.catch(err => {
				console.error('Failed to load mastery data:', err);
				setError('Failed to load mastery data');
				setRows([{ championName: 'Error loading data' }]);
				setSortedRows([{ championName: 'Error loading data' }]);
			});
	}

	function handleSort(column) {
		let newDirection = column === 'name' ? 'asc' : 'desc';
		if (sortColumn === column && sortDirection === 'desc') {
			newDirection = 'asc';
		}

		setSortColumn(column);
		setSortDirection(newDirection);

		const sorted = [...rows].sort((a, b) => {
			let aVal, bVal;

			switch (column) {
				case 'name':
					aVal = a.championName;
					bVal = b.championName;
					return newDirection === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);

				case 'level':
					aVal = a.championLevel;
					bVal = b.championLevel;
					return newDirection === 'asc' ? aVal - bVal : bVal - aVal;

				case 'points':
					aVal = a.championPointsRaw || 0;
					bVal = b.championPointsRaw || 0;
					return newDirection === 'asc' ? aVal - bVal : bVal - aVal;

				case 'playTime':
					aVal = a.lastPlayTime || 0;
					bVal = b.lastPlayTime || 0;
					return newDirection === 'asc' ? aVal - bVal : bVal - aVal;

				default:
					return 0;
			}
		});

		setSortedRows(sorted);
	}

	function epochToFriendlyTime(epochTimestamp) {
		if (epochTimestamp === 0) {
			return { 'absolute': "Never" };
		}

		// Convert epoch timestamp to milliseconds
		let currentTime = Date.now();
		let timeDifference = currentTime - epochTimestamp;

		// Define time intervals in milliseconds
		const minute = 60 * 1000;
		const hour = 60 * minute;
		const day = 24 * hour;
		const week = 7 * day;
		const month = 30 * day;
		const year = 365 * day;

		var amount;
		var unit;

		if (timeDifference < minute) {
			return { 'absolute': "Just now" };
		} else if (timeDifference < 2 * hour) {
			const minutes = Math.floor(timeDifference / minute);
			amount = minutes;
			unit = "min";
		} else if (timeDifference < 2 * day) {
			const hours = Math.floor(timeDifference / hour);
			amount = hours;
			unit = "hr";
		} else if (timeDifference < 2 * week) {
			const days = Math.floor(timeDifference / day);
			amount = days;
			unit = "d";
		} else if (timeDifference < 2 * month) {
			const weeks = Math.floor(timeDifference / week);
			amount = weeks;
			unit = "wk";
		} else if (timeDifference < 2 * year) {
			const months = Math.floor(timeDifference / month);
			amount = months;
			unit = "mo";
		} else {
			const years = Math.floor(timeDifference / year);
			amount = years;
			unit = "yr";
		}

		return {
			'amount': amount,
			'unit': unit
		};
	}

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
}


// Catch 'Em All challenge id = 401101

async function getDataDragonRealm(region) {
	return fetch(`https://ddragon.leagueoflegends.com/realms/${region.toLowerCase()}.json`)
		.then(rawResponse => rawResponse.json())
		.then(response => { return response; })
		.catch(error => console.warn(error));
}

function corsProxyURL(url) { return 'https://corsproxy.io/?' + encodeURIComponent(url); }

async function getRiotAccount(gameName, tagLine, apiKey) {
	console.log(`Getting riot account: ${gameName}#${tagLine}`);
	return fetch(corsProxyURL(`https://americas.api.riotgames.com/riot/account/v1/accounts/by-riot-id/${gameName.replace(/ /g, "%20")}/${tagLine}?api_key=${apiKey}`))
		.then(rawResponse => rawResponse.json())
		.then(response => {
			console.log(`Retrieved riot account: ${response.gameName}#${response.tagLine}`);
			return response;
		})
		.catch(error => console.warn(error));
}

async function getSummonerByPUUID(puuid, apiKey) {
	return fetch(corsProxyURL(`https://na1.api.riotgames.com/lol/summoner/v4/summoners/by-puuid/${puuid}?api_key=${apiKey}`))
		.then(rawResponse => rawResponse.json())
		.then(response => {
			console.log(`Retrieved summoner: ${response.name}`);
			return response;
		})
		.catch(error => console.warn(error));
}

async function getMasteryList(puuid, apiKey) {
	return fetch(corsProxyURL(`https://na1.api.riotgames.com/lol/champion-mastery/v4/champion-masteries/by-puuid/${puuid}?api_key=${apiKey}`))
		.then(rawResponse => rawResponse.json())
		.then(response => { return response; })
		.catch(error => console.warn(error));
}

export default CatchEmAll;
